import { computedFrom } from "aurelia-binding";
import { autoinject } from "aurelia-dependency-injection";
import { GhgService } from "../../../../../../../../services/ghg/ghg.service";
import { DoesVesselCiiExistRequest, GhgVerificationRequestModel } from "../../../../../../../../models/ghgs/ghg.models";
import { BaseEnvironmentalVerificationTab } from "../base-environmental-verification-tab";
import * as moment from "moment";
import { Reflection } from "../../../../../../../../utilities/reflection";
import { useView } from "aurelia-framework";

@autoinject
@useView('views/pages/modules/ghg/pages/request-an-environmental-verification/tabs/environmental-verification-cii/environmental-verification-cii.html')
export class EnvironmentalVerificationCii extends BaseEnvironmentalVerificationTab {

    private _ciiRatingYear: Date;

    public ciiFiles: File[] = [];
    public ciiCorrectiveActionPlanFiles: File[] = [];
    public hasUnacceptableCiiRatings: boolean = false;
    public todaysDate: Date = moment().toDate();
    
    constructor(private ghgService: GhgService) {
        super();
    }

    @computedFrom("hasUnacceptableCiiRatings", "ghgVerification.ghgVerificationCii.ciiRating")
    get isCorrectiveActionPlanRequired() : boolean {
        let result = false;
        if (this.ghgVerification && this.ghgVerification.ghgVerificationCii.ciiRating == 'E' || 
            (this.hasUnacceptableCiiRatings && this.ghgVerification.ghgVerificationCii.ciiRating == 'D')) {
            result = true;
        }

        return result;
    }

    @computedFrom("ghgVerification.ghgVerificationCii.ciiRatingYear")
    get isCiiRatingYearExisting(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            if(this.vessel != null && this.vessel.vesselId != null && this.ghgVerification.ghgVerificationCii.ciiRatingYear != null) {
                const request: DoesVesselCiiExistRequest = { vesselId: this.vessel.vesselId, ciiRatingYear: this.ghgVerification.ghgVerificationCii.ciiRatingYear };
                this.ghgService.doesVesselCiiExist(request).then(resolve, reject);
            }
            else {
                resolve(false);
            }
        });
    }

    @computedFrom(Reflection.getPropertyPath<EnvironmentalVerificationCii>(z => z._ciiRatingYear))
    public get ciiRatingYear(): Date {
        return this._ciiRatingYear;
    }

    public set ciiRatingYear(value: Date) {
        this._ciiRatingYear = value;
        this.ghgVerification.ghgVerificationCii.ciiRatingYear = moment(value).year();
    }
    
    activate(model: GhgVerificationRequestModel): void {
        super.activate(model);
        this._ciiRatingYear = null;
        this.ciiFiles = model.ciiFiles;
        this.ciiCorrectiveActionPlanFiles = model.ciiCorrectiveActionPlanFiles;
        this.ghgService.getHasUnacceptableCiiRatings(model.vessel.vesselId).then(response => {
            if (response) {
                this.hasUnacceptableCiiRatings = response.hasUnacceptableCiiRatings;
            }
        });
    }

    setCiiRating(letter: string){
        this.ghgVerification.ghgVerificationCii.ciiRating = letter;
    }
}